import { render, staticRenderFns } from "./orderserver.vue?vue&type=template&id=6fff5b67&scoped=true&"
import script from "./orderserver.vue?vue&type=script&lang=js&"
export * from "./orderserver.vue?vue&type=script&lang=js&"
import style0 from "./orderserver.vue?vue&type=style&index=0&lang=css&"
import style1 from "./orderserver.vue?vue&type=style&index=1&id=6fff5b67&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fff5b67",
  null
  
)

export default component.exports